import React, { useCallback, useEffect, useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { apiRequest } from '../utils/api';
import { useNavigate } from 'react-router-dom';

const emptyForm = { title: '', message: '', alertType: 'note', reminderDate: '', priority: 'medium', status: 'active' };

const Alerts = () => {
  const navigate = useNavigate();
  const [alerts, setAlerts] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editId, setEditId] = useState(null);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    try {
      setError('');
      const res = await apiRequest('/api/admin/alerts', {}, navigate);
      setAlerts(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      setError(e.message || 'Failed to load alerts');
    }
  }, [navigate]);

  useEffect(() => { load(); }, [load]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!form.title.trim() || !form.message.trim()) {
      setError('Title and message are required.');
      return;
    }
    try {
      setError('');
      if (editId) {
        await apiRequest(`/api/admin/alerts/${editId}`, { method: 'PUT', body: form }, navigate);
      } else {
        await apiRequest('/api/admin/alerts', { method: 'POST', body: form }, navigate);
      }
      setForm(emptyForm);
      setEditId(null);
      await load();
    } catch (e) {
      setError(e.message || 'Failed to save alert');
    }
  };

  return (
    <DashboardLayout title="Alerts">
      <div className="card border-0 shadow-sm mb-3">
        <div className="card-body">
          <h5 className="mb-3">Notes & Reminders</h5>
          {error && <div className="alert alert-danger">{error}</div>}
          <form className="row g-2" onSubmit={handleSubmit}>
            <div className="col-md-3"><input className="form-control" placeholder="Title" value={form.title} onChange={(e) => setForm((p) => ({ ...p, title: e.target.value }))} /></div>
            <div className="col-md-4"><input className="form-control" placeholder="Message" value={form.message} onChange={(e) => setForm((p) => ({ ...p, message: e.target.value }))} /></div>
            <div className="col-md-2"><select className="form-select" value={form.alertType} onChange={(e) => setForm((p) => ({ ...p, alertType: e.target.value }))}><option value="note">Note</option><option value="reminder">Reminder</option></select></div>
            <div className="col-md-3"><input type="date" className="form-control" value={form.reminderDate || ''} onChange={(e) => setForm((p) => ({ ...p, reminderDate: e.target.value }))} /></div>
            <div className="col-md-2"><select className="form-select" value={form.priority} onChange={(e) => setForm((p) => ({ ...p, priority: e.target.value }))}><option value="low">Low</option><option value="medium">Medium</option><option value="high">High</option></select></div>
            <div className="col-md-2"><select className="form-select" value={form.status} onChange={(e) => setForm((p) => ({ ...p, status: e.target.value }))}><option value="active">Active</option><option value="inactive">Inactive</option><option value="completed">Completed</option></select></div>
            <div className="col-md-2"><button className="btn btn-danger w-100" type="submit">{editId ? 'Update' : 'Create'}</button></div>
          </form>
        </div>
      </div>
      <div className="card border-0 shadow-sm">
        <div className="table-responsive">
          <table className="table mb-0">
            <thead><tr><th>Title</th><th>Type</th><th>Reminder</th><th>Priority</th><th>Status</th><th>Action</th></tr></thead>
            <tbody>
              {alerts.map((alert) => (
                <tr key={alert.id}>
                  <td><div>{alert.title}</div><small className="text-muted">{alert.message}</small></td>
                  <td>{alert.alertType}</td>
                  <td>{alert.reminderDate || '-'}</td>
                  <td><span className={`badge ${alert.priority === 'high' ? 'bg-danger' : alert.priority === 'medium' ? 'bg-warning text-dark' : 'bg-secondary'}`}>{alert.priority}</span></td>
                  <td><span className={`badge ${alert.status === 'active' ? 'bg-success' : alert.status === 'completed' ? 'bg-primary' : 'bg-secondary'}`}>{alert.status}</span></td>
                  <td>
                    <button className="btn btn-sm btn-outline-primary me-2" onClick={() => { setEditId(alert.id); setForm({ title: alert.title || '', message: alert.message || '', alertType: alert.alertType || 'note', reminderDate: alert.reminderDate || '', priority: alert.priority || 'medium', status: alert.status || 'active' }); }}>Edit</button>
                    <button className="btn btn-sm btn-outline-danger" onClick={async () => { await apiRequest(`/api/admin/alerts/${alert.id}`, { method: 'DELETE' }, navigate); load(); }}>Delete</button>
                  </td>
                </tr>
              ))}
              {alerts.length === 0 && <tr><td colSpan={6} className="text-center text-muted py-3">No alerts</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Alerts;
